import "views/SignInFlow/SignUp/SignUp.css"
import {useDispatch} from 'react-redux'
import {SignInFlowJson, SignUpUserTypeJson, SignUpUserType} from "views/SignInFlow/SignInFlowJson";
import SignInNavBar from "components/layout/navigation/SignInNavBar/SignInNavBar";
import SelectUserType from "components/buttons/SelectUserType/SelectUserType";
import {updateUserType} from "store/ui/userType/userType.slice";
import {updateSignUpScreen} from "store/ui/signUpScreen/signUpScreen.slice";

function SignUp() {
  const dispatch = useDispatch();

  // on user clicking a user type, update redux sign up user type and update screen
  const onClick = (userType: SignUpUserType) => {
    dispatch(updateUserType(userType));
    dispatch(updateSignUpScreen("SignUpThankYouScreen"))
  }

  return (
    <div className={'sign-up-right-container'}>
      <SignInNavBar/>

      <div className={"sign-up-welcome"}>
        <div id={"select-user-type"}>
          <h1> Welcome to BENEVV! </h1>
          <p className={"welcome-subtext"}> A Social Giving Community </p>
          <p id={"welcome-select"}> Select user type to register </p>
          <SelectUserType userTypeJson={SignInFlowJson.myself} onClick={() => onClick(SignUpUserTypeJson.myself)}/>
          <SelectUserType userTypeJson={SignInFlowJson.nonProfit} onClick={() => onClick(SignUpUserTypeJson.nonProfit)}/>
          <SelectUserType userTypeJson={SignInFlowJson.brand} onClick={() => onClick(SignUpUserTypeJson.brand)}/>
        </div>
      </div>
    </div>
  )
}

export default SignUp;
